import { EventType } from '@src/dtos/analytics.dto';
import { exportSinglePDF } from '@src/utils/export-to-pdf-utils';
import CustomIcon, { IconType } from '@src/components/shared/custom-icon/custom-icon';
import CustomButton from '@src/components/shared/custom-button/custom-button';
import React, { FC, useState } from 'react';
import { useStores } from '@src/components/store';
import { handleDateRange } from '@src/utils/datesUtils';

interface ExportReportProps {
    reportName: string;
    isLoading: boolean;
    contentClass: string;
    orientation?: 'p' | 'l';
}

export const ExportReport: FC<ExportReportProps> = ({reportName, isLoading, contentClass, orientation = 'l'}) => {

    const { uiStore, customerStore, reportsStore } = useStores();
    const { fromDate, toDate } = handleDateRange(reportsStore.dateRange);
    const [isExporting, setIsExporting] = useState(false);

    const exportPDF = async () => {
        setIsExporting(true);
        uiStore.sendGeneralEvent(EventType.ReportsExport, { reportName });
        const pdfName = `${reportName}-${customerStore.serviceName?.replaceAll('/', '.') ?? ''}`;
        try {
            await exportSinglePDF(pdfName, orientation, contentClass, fromDate, toDate);
        } finally {
            setIsExporting(false);
        }
    };

    return <CustomButton prefixIcon={<CustomIcon type={IconType.EXPORT}/>} className={`secondary-btn export`} onClick={exportPDF}
                         isDisabled={isLoading || isExporting} />;
};